<script lang="ts">

    import Players from "./Players.svelte";
    import Sheet from "./Sheet.svelte";
    import Home from "./Home.svelte";
    import Team from "./Team.svelte";
    import Router, { push, location } from 'svelte-spa-router'
    import { onMount, setContext } from "svelte"
    import {season, team} from './store';    
    import Login from "./Login.svelte"
    import { type AuthorizedResult, authorized, unauthorizedAccess  } from "./src/types"
    import Fa from 'svelte-fa/src/fa.svelte';
    import { faPerson, faPeopleGroup, faSheetPlastic, faRightFromBracket, faShare} from '@fortawesome/free-solid-svg-icons/index.js';
    import { openShare } from "./src/client"
    import Share from "./Share.svelte"
    import ShareWrapper from "./ShareWrapper.svelte"

    const routes = {
        // Exact path
        
        // Using named parameters, with last being optional
        '/players/:season/:team': Players,
        '/team/:season/:team': Team,
        '/sheet/:id?':Sheet,        
        '/newsheet':Sheet,   
        '/login': Login,
        '/share/:link': ShareWrapper,
        '*': Home,
    }

    let authenticated:boolean = true;

    let seasons : string[] = []

    let teams : string[] = []

    let teamSelection : string;

    let seasonSelection : string;

    let getSeasons = async ():Promise<AuthorizedResult<string[]>> => {
		let r = await fetch(`/seasons`,
		{
			method:"GET"
		});		
        if (r.status == 401) {
            authenticated = false;
            return unauthorizedAccess();
        }
		if (r.status != 200) {
			console.log('zut');
			console.log(`une erreur est survenue ${r.status}:${r.statusText}`);
		}
        const seasons:string[] = await r.json();
		return authorized(seasons)		
	}

    let getTeams = async ():Promise<AuthorizedResult<string[]>> => {
		let r = await fetch(`/teams/${$season}`,
		{
			method:"GET"
		});
		console.log(r);
        if (r.status == 401) {  
            authenticated = false;
            return unauthorizedAccess();
        }
		if (r.status != 200) {
			console.log('zut');
			console.log(`une erreur est survenue ${r.status}:${r.statusText}`);
		}        
		const teams:string[] = await r.json();
		return authorized(teams);		
	}


    let loadData = async() => {
        const s = await getSeasons();
        console.log('   => ',s);
        if (s.authorized) {
            seasons = s.result;
        }
        else {
            authenticated = false;
            push('/login');
            return;
        }
        console.log('seasons',seasons)
        $season = seasons[0];
        seasonSelection = seasons[0];
        const t = await getTeams();
        console.log('       => ',t)
        if (t.authorized) {
            teams = t.result;
        }
        else {
            authenticated = false;
            push('/login');
            return;
        }
        console.log('load data done => auth OK');
        $team = teams[0];
        teamSelection = teams[0];
        authenticated = true;
    }

    let isAuthenticated = () => {
        return authenticated;
    }

    let setAuthenticated = (auth:boolean) => {
        authenticated = auth;
    }

    setContext('isAuthenticated',isAuthenticated);
    setContext('setAuthenticated',setAuthenticated);

    setContext('loadData',loadData);

    let url:Location;

    onMount(async () => {
        url = window.location;
        
        console.log(`App.onMount(${$location}) @ ${url}`);
        if (!$location.startsWith('/share')) {   
            console.log(`App.onMount() call loaddata - ${$location}`);     
            await loadData();
        }
    });

    const selectSeason = async () => {
        $season = seasonSelection;
        const t = await getTeams();
        if (t.authorized) {            
            teams = t.result;
        }
        else {
            authenticated = false;
            push('/login');
            return;
        }
        $team = teams[0];        
        teamSelection = $team;
        seasonSelection = seasonSelection;
    }

    const selectTeam = () => {
        $team = teamSelection;              
        teamSelection = teamSelection;
        push('#/');      
        return;  
    }

    $: {
        teamSelection = teamSelection;
        console.log(seasonSelection+" - "+teamSelection);
    }

    const logout = async () => {
        teamSelection = undefined;
        teams = [];
        seasonSelection = undefined;
        seasons = [];
        let r = await fetch(`/logout`,
		{
			method:"DELETE"
		});
		console.log(r);
        authenticated = false;
        push('/login')
    }

    const share = async () => {
        let r = await fetch('/share', {
            method: "POST",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: '*/*',
            },
            body: new URLSearchParams({
                season: seasonSelection,
                team: teamSelection,
            })
        });
        if (r.status == 200) {
            const link = await r.text();
            console.log(`share link for ${seasonSelection}/${teamSelection} is ${link} @ ${url}`);
            navigator.clipboard.writeText(url.origin+"/#/share/"+link).then((x) => {
                console.log('success',x)
            }).catch((reason) => {
                console.log('rejected ',reason);
            }).finally(() => {
                console.log('copy done ... or not');
            })
        }
    }

</script>

<div style="display:flex;flex-direction:column">
{#if (authenticated)}
    <div style="display:flex;flex-direction: row;">
        
        <select bind:value={seasonSelection} on:change={selectSeason}>
        
                {#each seasons as season}
                    <option value="{season}"  >{season}</option>
                {/each} 
            
        </select>
        <select bind:value={teamSelection} on:change={selectTeam}>        
                {#each teams as team}
                    <option value="{team}" >{team}</option>
                {/each}         
        </select>    
    </div>
    <div style="display:flex;flex-direction:row">
        
        <button on:click={() => {push(`/players/${seasonSelection}/${teamSelection}`)}} style="float:left; width:100%"><Fa icon="{faPerson}" size="2x"/>vue joueurs</button>
        <button on:click={() => {push(`/team/${seasonSelection}/${teamSelection}`)}} style="float:right; width: 100%"><Fa icon="{faPeopleGroup}" size="2x"/>vue équipe</button>    
        <button on:click={() => {console.log('opening new match sheet');push(`/newsheet/`);}} style="float:right; width: 100%"><Fa icon="{faSheetPlastic}" size="2x"/>Saisir une feuille de match</button>    
        <button on:click={share} style="float:right; width: 100%"><Fa icon="{faShare}" size="2x"/>Partage</button>
        <button on:click={logout} style="float:right; width: 100%"><Fa icon="{faRightFromBracket}" size="2x"/>Déconnection</button>
    
    </div>
{/if}
<div style="display:flex;flex-direction:column">
<Router {routes}/>
</div>
</div>